// Pesquisa de satisfação
export const SURVEY_CODE = 'nps'

// Tipos de resposta
export const answerType = {
  TEXT: 'TEXT',
  SCORE: 'SCORE',
  REVIEW: 'REVIEW',
}

// Perguntas do NPS
export const questions = [
  {
    code: 'QET01001',
    text: 'O quanto você recomenda a Telavita?',
    answerType: answerType.SCORE
  },
  {
    code: 'QET01002',
    text: 'O quanto você recomenda este profissional?',
    answerType: answerType.REVIEW
  },
  {
    code: 'QET01005',
    text: 'Qual seu nível de felicidade consigo mesmo?',
    answerType: answerType.SCORE
  },
  {
    code: 'QET01004',
    text: 'Aqui você pode elogiar, criticar ou sugerir. Fique à vontade :)',
    answerType: answerType.TEXT
  },
]

export const reviewsText = {
  POSITIVE: 'Ele poderá aparecer no perfil do profissional. Caso apareça, mostraremos apenas as iniciais do seu nome, sem foto.',
  NEGATIVE: 'Nossa equipe de gestão clínica avaliará o seu depoimento, e em casos necessários, notificará o profissional.'
}